import type { UITabItem } from '@/core/data/config/uiConfig.interface';
import { TabItemType } from '@/core/data/config/uiConfig.interface';
import type { UserDto } from '@/core/data/user/user.interface';
import { GamStoreId } from '@/views/composables/constants/main/store.constants';
import type { GamTabItemType } from '@/views/composables/models/components/GamTab';
import { defineStore } from 'pinia';
import { ref } from 'vue';

const MAX_PROFILE_CACHE_SIZE = 20;

export const usePlayerStore = defineStore(GamStoreId.PLAYER, () => {
  const playerDetailsTabItems = ref<GamTabItemType[] | null>(null);
  const profileCache = new Map<string, UserDto>();

  const setPlayerListTabItems = (tabItems: UITabItem[] | null) => {
    playerDetailsTabItems.value = tabItems;
    setActive(TabItemType.ALL);
  };

  const setActive = (name: TabItemType): void => {
    playerDetailsTabItems.value?.map((item) => {
      item.isActive = item.name === name;
    });
  };

  const getActiveTab = (): TabItemType | undefined => {
    const activeTabItem: GamTabItemType | undefined = playerDetailsTabItems.value?.find(
      (item) => item.isActive && item.name !== TabItemType.ALL,
    );

    return activeTabItem?.name;
  };

  function getCachedProfile(username: string): UserDto | null {
    return profileCache.get(username) ?? null;
  }

  function setCachedProfile(username: string, data: UserDto) {
    profileCache.set(username, data);
    if (profileCache.size > MAX_PROFILE_CACHE_SIZE) {
      const oldest = profileCache.keys().next().value;
      if (oldest) profileCache.delete(oldest);
    }
  }

  return {
    playerDetailsTabItems,
    setPlayerListTabItems,
    setActive,
    getActiveTab,
    getCachedProfile,
    setCachedProfile,
  };
});
